<template>
  <div v-if="user.mfa_enabled">
    <a-collapse accordion defaultActiveKey="1" v-if="!loading">
      <a-collapse-panel header="TOTP (For Authenticator Apps)" key="1" v-if="mfa_options.totp.enabled">
        <a-barcode-otp otpType="totp" key="1" />
      </a-collapse-panel>
      <a-collapse-panel header="HOTP (For Authenticator Apps)" key="2" v-if="mfa_options.hotp.enabled">
        <a-barcode-otp otpType="hotp" />
      </a-collapse-panel>
      <a-collapse-panel header="Backup codes" key="3">
        <a-backupcode-otp /> 
      </a-collapse-panel>
    </a-collapse>
  </div>
  <div v-else>
    <a-alert type="error">
      <h3 slot="message">MFA not enabled</h3>
      <div slot="description">
        Please enable your MFA settings in update profile section.
      </div>
    </a-alert>
  </div>
</template>

<script>
import ABarcodeOtp from "@/components/UserSettings/ABarcodeOtp";
import ABackupcodeOtp from "@/components/UserSettings/ABackupcodeOtp";

export default {
  components: {
    ABarcodeOtp,
    ABackupcodeOtp
  },
  data() {
    return {
      loading: true
    }
  },
  computed: {
    mfa_options() {
      return this.$store.state.axioms.mfa_item
        ? this.$store.state.axioms.mfa_item
        : null;
    },
    user() {
      return this.$store.state.axioms.users_item
        ? this.$store.state.axioms.users_item
        : {};
    }
  },

  beforeCreate: async function(){
    try {
      await this.$store.dispatch("axioms/getItem", {
        endpoint: 'mfa',
        uuid: 'options'
      });
      this.loading = false;
    } catch (error) {
      console.error(error);
      this.loading = false;
    }
  },
};
</script>

<style lang="css">
.mfa-p {
  font-size: 1.1em;
}
</style>